{
  "warsh": {
    "id": "warsh",
    "ar": "ورش عن نافع",
    "en": "Warsh",
    "enabled": true,
    "activities": [
      "tasmi3",
      "tilawa"
    ]
  },
  "hafs": {
    "id": "hafs",
    "ar": "حفص عن عاصم",
    "en": "Hafs",
    "enabled": true,
    "activities": [
      "tasmi3",
      "tilawa",
      "talqin"
    ]
  },
  "bazzi": {
    "id": "bazzi",
    "ar": "البزي عن ابن كثير",
    "en": "Al-Bazzi",
    "enabled": false,
    "activities": []
  },
  "duri_abuamr": {
    "id": "duri_abuamr",
    "ar": "الدوري عن أبي عمرو",
    "en": "Al-Duri (Abu Amr)",
    "enabled": false,
    "activities": []
  },
  "hisham": {
    "id": "hisham",
    "ar": "هشام عن ابن عامر",
    "en": "Hisham",
    "enabled": false,
    "activities": []
  },
  "khalaf_hamzah": {
    "id": "khalaf_hamzah",
    "ar": "خلف عن حمزة",
    "en": "Khalaf (Hamzah)",
    "enabled": false,
    "activities": []
  },
  "abulharith": {
    "id": "abulharith",
    "ar": "أبو الحارث عن الكسائي",
    "en": "Abu al-Harith",
    "enabled": false,
    "activities": []
  },
  "ibnwardan": {
    "id": "ibnwardan",
    "ar": "ابن وردان عن أبي جعفر",
    "en": "Ibn Wardan",
    "enabled": false,
    "activities": []
  },
  "ruways": {
    "id": "ruways",
    "ar": "رويس عن يعقوب",
    "en": "Ruways",
    "enabled": false,
    "activities": []
  },
  "ishaq": {
    "id": "ishaq",
    "ar": "إسحاق عن خلف العاشر",
    "en": "Ishaq",
    "enabled": false,
    "activities": []
  }
}